'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Span from '../tag/Span';
import Row from '../tag/Row';
import classnames from 'classnames';

const HoitopolkuBlock = ({
  disabled,
  enabledlogoSrc,
  disabledLogoSrc,
  name,
  status,
}) => {
  let _color = `hoitopolku-block_${status}`;
  let logoSrc = disabled ? disabledLogoSrc : enabledlogoSrc;
  return (
    <Row className="hoitopolku-block ot-card__hpBlock ot-card">
      <Span len="3">
        <img src={logoSrc} />
      </Span>
      <Span len="6">
        <div
          className={classnames('hoitopolku-block__desc ot-card__image-title', {
            'ot-card__image-title--disabled': disabled,
          })}
        >
          {name}
        </div>
      </Span>
      <Span len="3">
        <div
          className={classnames('hoitopolku-block__status', {
            [_color]: _color != null,
          })}
        >
          <FormattedMessage id={status} />
        </div>
      </Span>
    </Row>
  );
};

export default HoitopolkuBlock;
